import React from 'react'
import vsbl from 'vsbl'

import store from '../../state/store.js'
import PageLink from '@/link.js'
import Image from '@/image.js'
import { Arrow, SquiggleGroup } from '@/svgs.js'

const switchBackground = (value) => {
  store.hydrate({
    background: value
  })()
}

class ExperienceModule extends React.Component {
  constructor () {
    super()

    this.vs = null

    this.slideshow = React.createRef()
    this.slideshowSecond = React.createRef()
    this.leftArrow = React.createRef()
    this.rightArrow = React.createRef()
  }
  componentDidMount () {
    const Flickity = require('flickity')
    const slideshow = this.slideshow.current
    const flky = new Flickity(slideshow, {
      contain: true,
      wrapAround: true,
      pageDots: false,
      bgLazyLoad: 2,
      cellAlign: 'center',
      prevNextButtons: false
    })
    const slideshowSecond = this.slideshowSecond.current
    const flkyTwo = new Flickity(slideshowSecond, {
      contain: true,
      wrapAround: true,
      draggable: false,
      pageDots: false,
      bgLazyLoad: 2,
      initialIndex: 1,
      cellAlign: 'center',
      prevNextButtons: false
    })

    setTimeout(() => {
      flkyTwo.resize()
    }, 400)

    const left = this.leftArrow.current
    const right = this.rightArrow.current

    left.addEventListener('click', () => {
      flky.previous()
      flkyTwo.previous()
    })
    right.addEventListener('click', () => {
      flky.next()
      flkyTwo.next()
    })

    this.vs = vsbl(this.slideshow.current)(() => {
      switchBackground('two')
    }, () => {
      switchBackground('one')
    })

    this.vs.update()
  }
  componentWillUnmount() {
    this.vs.destroy()
  }
  render () {
    const {
      title,
      description,
      featuredLocation,
      ctaCopy,
    } = this.props.content
    return (
      <div className='ac pmy experience'>
        <div className='container--xl ma p1 mb15'>
          <h2 className='mb0 pb0 h1'>{title}</h2>
          <p className='container--i ma mb1 mt1 s22 pb1'>{description}</p>
          <PageLink to='/events' className='button button__peach inline-block button__outline'>
            <span>{ctaCopy}</span>
          </PageLink>
        </div>
        <div className='x experience__wrapper f jcb fw'>
          <div className='experience__slideshow mb15 rel x'>
            <div className='slideshow__arrows f fw aic abs z1 bottom right p1'>
              <div className='slideshow__arrows-item rel z1 m05 f jcc aic rotate' ref={this.leftArrow}>
                <Arrow />
              </div>
              <div className='slideshow__arrows-item rel z1 m05 f jcc aic' ref={this.rightArrow}>
                <Arrow />
              </div>
            </div>
            <div className='experience__slideshow-main' ref={this.slideshow}>
              {featuredLocation.locationPhotos.map(photo => (
                <div className='x' key={photo._key}>
                  <div className='experience__slideshow-photo abs z1 x y top left'>
                    <Image imageId={photo.imageId} />
                  </div>
                  <Image className='experience__sizer' imageId={featuredLocation.locationPhotos[0].imageId} />
                </div>
              ))}
            </div>
          </div>
          <div className='experience__location x'>
            <div className='experience__location-second x'>
              <div className='experience__slideshow-main' ref={this.slideshowSecond}>
                {featuredLocation.locationPhotos.map(photo => (
                  <div className='x' key={photo._key}>
                    <div className='experience__slideshow-photo abs z1 x y top left'>
                      <Image imageId={photo.imageId} />
                    </div>
                    <Image imageId={featuredLocation.locationPhotos[0].imageId} />
                  </div>
                ))}
              </div>
            </div>
            <div>
              <span className='h5 caps mb1 pt1 block medium pb0'>Union Square</span>
              <div>
                <h4 className='m0 p0 squiggle__block inline-block'>
                  <span className='rel'>
                    {featuredLocation.address}
                    <SquiggleGroup />
                  </span>
                </h4>
              </div>
              <h4 className='m0 p0 squiggle__block inline-block'>
                <span className='rel'>
                  {featuredLocation.title}
                  <SquiggleGroup />
                </span>
              </h4>
              <span className='h5 caps mb1 mt1 pt1 block medium pb0'>Hours</span>
              <p className='mb0 mt0 pb1' dangerouslySetInnerHTML={{ __html: featuredLocation.hours.replace(/[\r\n]+/g, '<br />') }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ExperienceModule
